// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__ycSvW","form":"styles_form__XfLPl"};